<template>
  <header>
    <b-navbar type="dark" variant="dark" style="background-color: var(--navbar-bg);">
      <b-button variant="outline" @click="$router.back()" :disabled="!backButton" v-if="showBackButton" aria-label="Назад">
        <b-icon variant="white" icon="chevron-left"/>
      </b-button>
      <b-navbar-brand to="/dashboard" replace style="margin-left: 15px">
        <img src="/static/logo-white.png" width="100" class="d-inline-block align-top" alt="Fix Audit">
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto" role="navigation">
        <!-- DESIGN-2: Theme switcher -->
        <b-nav-item @click="toggleTheme" aria-label="Переключить тему" title="Переключить тему">
          <b-icon :icon="currentTheme === 'dark' ? 'sun-fill' : 'moon-stars-fill'" variant="light"/>
        </b-nav-item>
        <b-nav-item-dropdown right aria-label="Меню пользователя">
          <template #button-content>
            <b-icon icon="person-fill" variant="light"/>
          </template>
          <b-dropdown-item @click="$router.push('/profile')">
            <b-icon variant="black" icon="person-fill"/>
            <label class="ml-2">Профиль</label>
          </b-dropdown-item>
          <b-dropdown-item @click="$router.push('/settings')" v-if="$store.state.role === 'Admin'">
            <b-icon variant="black" icon="sliders"/>
            <label class="ml-2">Настройки</label>
          </b-dropdown-item>
          <b-dropdown-item :href="getUrl('/api/schema/swagger-ui.html')" target="_blank">
            <b-icon variant="danger" icon="code-slash"/>
            <label class="ml-2">Fix Audit API</label>
          </b-dropdown-item>
          <b-dropdown-item @click.native.prevent="logout">
            <b-icon variant="secondary" icon="box-arrow-right"/>
            <label class="ml-2">Выход</label>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
  </header>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi'
import { refreshTokenKey } from '@/backend/tokens'

export default {
  name: 'mainHeader',
  mixins: [RekonoApi],
  data () {
    return {
      backButton: false,
      showBackButton: false,
      currentTheme: 'dark'
    }
  },
  mounted () {
    this.currentTheme = localStorage.getItem('fix-audit-theme') || 'dark'
    document.documentElement.setAttribute('data-theme', this.currentTheme)
  },
  methods: {
    toggleTheme () {
      this.currentTheme = this.currentTheme === 'dark' ? 'light' : 'dark'
      document.documentElement.setAttribute('data-theme', this.currentTheme)
      localStorage.setItem('fix-audit-theme', this.currentTheme)
    },
    logout () {
      this.post('/api/logout/', { refresh_token: sessionStorage.getItem(refreshTokenKey) })
      this.$store.dispatch('logout')
    }
  },
  watch: {
    $route (to, from){
      if (from && from.name) {
        this.backButton = true
      } else {
        this.backButton = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$dark: black;
@import 'bootstrap/scss/bootstrap';
</style>